import type { OrderSource, OrderType } from "../types/order";

/**
 * Feature 273 — declared, not imported: this module pulls in nothing at
 * runtime. Not exported, because the barrel next to it re-exports a sibling
 * that already carries this name, and two of them would collide.
 */
type TFn = (key: string, fallback: string) => string;

export function formatOrderSource(source: OrderSource, t: TFn): string {
  const map: Record<OrderSource, string> = {
    PHONE: t("order.source.phone", "Telefono"),
    WAITER: t("order.source.waiter", "Cameriere"),
    QR: t("order.source.qr", "QR Code"),
    CRM: t("order.source.crm", "CRM"),
  };
  return map[source] || source;
}

export function formatOrderType(type: OrderType, t: TFn): string {
  const map: Record<OrderType, string> = {
    DINE_IN: t("order.type.dineIn", "Al tavolo"),
    TAKEAWAY: t("order.type.takeaway", "Asporto"),
    DELIVERY: t("order.type.delivery", "Consegna"),
    COUNTER: t("order.type.counter", "Banco"),
  };
  return map[type] || type;
}

export function formatPrice(cents: number): string {
  return `€${(cents / 100).toFixed(2)}`;
}

export function formatDailyNumber(n: number): string {
  return `#${String(n).padStart(3, "0")}`;
}
